import React from 'react';

const FlowStep = ({ number, label, sublabel }) => (
  <div className="text-center flex-1">
    <div className="w-12 h-12 rounded-xl bg-green-500/10 border border-green-500/30
                    flex items-center justify-center mx-auto mb-3
                    text-lg font-bold text-green-500">
      {number}
    </div>
    <div className="font-semibold text-zinc-50 text-sm">{label}</div>
    <div className="text-zinc-600 text-xs mt-1">{sublabel}</div>
  </div>
);

const FlowArrow = () => (
  <div className="text-zinc-700 text-xl hidden sm:block">→</div>
);

const FlowDiagram = ({ steps }) => {
  return (
    <div className="bg-dark-tertiary border border-dark-border rounded-xl p-6 sm:p-8">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-3">
        {steps.map((step, idx) => (
          <React.Fragment key={idx}>
            <FlowStep
              number={step.number}
              label={step.label}
              sublabel={step.sublabel}
            />
            {idx < steps.length - 1 && <FlowArrow />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default FlowDiagram;
